import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CrownLedger from "./pages/CrownLedger";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CrownLedger />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
